import { Machine } from './machining.model';

export type JournalMachine = Machine | 'both';

export type OperationType =
  | 'turning' | 'facing' | 'threading' | 'parting' | 'drilling'
  | 'boring' | 'knurling'
  | 'face-mill' | 'end-mill' | 'slotting' | 'fly-cutting'
  | 'other';

export interface OperationEntry {
  id: string;
  type: OperationType;
  rpm?: number;
  feed?: string;
  notes?: string;
}

export interface JournalEntry {
  id: string;
  date: string;            // YYYY-MM-DD
  machine: JournalMachine;
  moduleId?: string;
  project?: string;
  material?: string;
  sessionLength?: string;
  operations?: OperationEntry[];
  whatWentWell?: string;
  challenges?: string;
  notes?: string;
  createdAt: number;
  updatedAt?: number;
}

export interface MachinePhoto {
  id: string;
  journalEntryId: string;
  journalDate: string;
  caption?: string;
  storagePath: string;
  downloadUrl: string;
  uploadedAt: number;
}

export const LATHE_OPS: OperationType[] = ['turning', 'facing', 'threading', 'parting', 'drilling', 'boring', 'knurling', 'other'];
export const MILL_OPS: OperationType[] = ['face-mill', 'end-mill', 'drilling', 'slotting', 'boring', 'fly-cutting', 'other'];
export const ALL_OPS: OperationType[] = ['turning', 'facing', 'threading', 'parting', 'drilling', 'boring', 'knurling', 'face-mill', 'end-mill', 'slotting', 'fly-cutting', 'other'];

export function operationLabel(op: OperationType): string {
  switch (op) {
    case 'face-mill': return 'Face mill';
    case 'end-mill':  return 'End mill';
    case 'fly-cutting': return 'Fly cutting';
    default: return op.charAt(0).toUpperCase() + op.slice(1);
  }
}
